<section class='background-3' ngClass.gt-xs='section-desktop' ngClass.lt-sm='section-mobile' fxLayout='column'
    fxLayoutAlign='center center'>
    <img src="/assets/images/quotes-color.png" />
    <h1>TESTIMONIALS</h1>
    <h3>What our Users Say</h3>
    <div style='width:60%'>
        <ngu-carousel [inputs]="carouselBanner" [dataSource]="testimonials" class='carousel-slides'>
            <ngu-tile *nguCarouselDef="let item">
                <div fxLayout='column' fxLayoutAlign='center center'>
                    <h4>{{item.title}}</h4>
                    <p>{{item.quote}}</p>
                    <div class='signature'>{{item.signature}}</div>
                </div>
            </ngu-tile>
            <button NguCarouselPrev class='leftRs'>&lt;</button>
            <button NguCarouselNext class='rightRs'>&gt;</button>
        </ngu-carousel>
    </div>
</section>